<div class="mobile-block-container">
  <div class="mobile-block-card">

    <div class="mobile-block-logo">
      <img class="logo-icon" [src]="assets.rcLogoSrc" [alt]="assets.rcLogoAlt">
    </div>

    <div class="mobile-block-content">
      <h1 class="mobile-block-title">{{ title }}</h1>

      <p class="mobile-block-message">{{ messages.mobile }}</p>

      <p class="mobile-block-message">{{ messages.desktop }}</p>
    </div>

    <div class="mobile-block-footer">
      <p class="footer-learn">
        <a [href]="footer.learnMoreUrl" target="_blank" rel="noopener noreferrer">
          {{ footer.learnMoreText }}
        </a>
        {{ footer.learnMoreAbout }}
        <img [src]="footer.brandLogoSrc" [alt]="footer.brandLogoAlt" class="footer-brand-img">
      </p>
      <p class="footer-copy">{{ footer.copyright }}</p>
    </div>

  </div>
</div>